const contentful = require("contentful");

const client = contentful.createClient({
  // This is the space ID. A space is like a project folder in Contentful terms
  space: "xjsnrkybezyi",
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: "fSBFYMDNCY2AJ5l_7JsT3_tbH3qxFNaI6tiBDRVYSMo"
});

export { client };